import React, {Component} from "react";
import {ButtonSpeaker} from '../../helpers/rendererHelper'
import "./PlayerMini.css";
import Slider from "@mui/material/Slider";
import {defineSpecificUrl} from "../../helpers/configHelper";
import ReactPlayer from "react-player";
import {MiniPause, MiniPlay} from "../Icon";

export default class PlayerMini extends Component {

    constructor(props) {
        super(props);
        this.state = {
            autoplay: !!parseInt(props.autoplay),
            controls: false,
            error: false,
            isExtend: false,
            light: false,
            loaded: 0,
            locale: props.locale,
            muted: false,
            neverPlayed: true,
            playbackRate: 1.0,
            played: 0,
            playing: !!parseInt(props.autoplay),
            preview: props.preview,
            stationIndex: 0,
            stream: null,
            timeline: [],
            isHlsBuffered: props.isHlsBuffered,
            urlParam: props.tokens['token'] ? (props.url + '?token=' + props.tokens['token']) : props.url
        }
    }

    async componentDidMount() {
        var config = defineSpecificUrl(this.state.urlParam);
        this.setState({
            'url': this.state.autoplay ? this.state.urlParam : 'temp.mp3',
            'volume': 0.5,
            "stream": config.stations[0].streams[0]
        });
    }

    // Call at the creation or after load function
    // The config is not change here
    onPlayerReady = () => {
        if (!this.state.error && !this.state.neverPlayed && this.state.stream.format === 'hls') {
            // Get the hls player, it's undefined if the stream is not a HLS stream
            this.hlsPlayer = this.player.getInternalPlayer('hls');
            this.hlsPlayer.onFragBuffered(function (event, data) {
                this.bitrate = Math.round((8 * data.stats.total) / (data.frag.endDTS - data.frag.startDTS));
            })
        }
    }

    handlePlay = () => {
        if (this.state.neverPlayed) {
            this.setState({neverPlayed: false});
        }
        // First play
        if (this.state.stream.format === 'hls') {
            // reload HLS stream at the end
            this.setState({url: this.state.stream.url});
        } else {
            this.player.player.player.player.src = this.state.stream.url;
            this.player.player.player.player.load();
        }
        this.setState({playing: true});
    }

    handlePause = () => {
        // Stop loading
        if (this.state.stream.format === 'hls' && this.hlsPlayer) {
            this.hlsPlayer.stopLoad();
            // change the stream url for reload the right stream at the play
            this.setState({url: ''});
        } else {
            // Empty the src player to stop loading
            this.player.player.player.player.src = '';
            this.player.player.player.player.load();
        }
        this.setState({playing: false});
    }

    handleVolumeChange = (e, value) => {
        // 0.022 is the perfect value to block the slider
        this.setState({muted: value < 0.022, volume: parseFloat(value)});
    }

    handleToggleMuted = () => {
        const isMuted = this.state.muted;
        if (!isMuted) {
            this.setState({volumeTemp: this.state.volume});
            this.handleVolumeChange(null, 0);
        } else {
            this.handleVolumeChange(null, this.state.volumeTemp ?? 0);
        }
        this.setState({muted: !isMuted});
    }

    handleProgress = state => {
        let message = state;
        message.type = 'progress';
        window.top.postMessage(message, '*')
        this.setState(state);
    }

    ref = player => {
        this.player = player;
    }

    render() {
        const {
            defaultVolume, light, muted, playbackRate, playing, url, volume
        } = this.state;
        if (!this.state.stream) {
            return <div/>;
        }
        document.body.style.backgroundColor = '#ffffff';

        function ButtonPlayPause(props) {
            return props.playing ? <MiniPause id="pause" onClick={props.onClickPause}
                                              alt="pause"
                                              color={props.color}/> : <MiniPlay id="play" onClick={props.onClickPlay}
                                                                                alt="play"
                                                                                color={props.color}/>;
        }

        return <div className='player-wrapper mini-player' style={{backgroundColor: '#ffffff', color: '#000000'}}>
            <div id="player">
                <div id="controls">
                    <div id="player-buttons" className="buttons">
                        <ButtonPlayPause
                            onClickPlay={this.handlePlay}
                            onClickPause={this.handlePause}
                            color={'#0098FF'}
                            playing={playing}
                        />
                        <ButtonSpeaker
                            onClick={this.handleToggleMuted}
                            color={'#9F9F9F'}
                            muted={muted}
                        />
                        <Slider type='range' min={0} max={1} step={0.0000001} value={volume}
                                style={{color: '#0098FF'}}
                                defaultValue={defaultVolume}
                                id="volume"
                                onChange={this.handleVolumeChange}/>
                    </div>
                </div>
                <ReactPlayer
                    id="react-player"
                    ref={this.ref}
                    className='react-player'
                    url={url}
                    playing={playing}
                    light={light}
                    playbackRate={playbackRate}
                    volume={volume}
                    muted={muted}
                    onReady={this.onPlayerReady}
                    onProgress={e => this.handleProgress(e)}
                    config={{
                        file: {
                            attributes: {
                                crossOrigin: "anonymous"
                            }, hlsOptions: {
                                // Taille du buffer déjà lu à garder en cache (en seconde)
                                liveBackBufferLength: 0,
                                // Taille maximum du buffer pas encore lu à garder en cache (en seconde)
                                maxMaxBufferLength: 10,
                                // Nombre de seconde de décalage avec le live (en seconde)
                                liveSyncDuration: 10,
                                startPosition: 0
                            }
                        }
                    }}
                />
            </div>
        </div>;
    }
}
